export default {"src":"/_next/static/media/yellow_leaf.d8040366.svg","height":163,"width":140,"blurWidth":0,"blurHeight":0};